// @flow

const updateRooms = (subtype: string, room: any) => ({
  type: 'SCRIBE_DASHBOARD_ROOMS_UPDATE',
  subtype,
  room,
});

export const handleScribeDashboardWsMessage = (dispatch: Function, message: any) => {
  const { status, type, roomId } = message;
  dispatch(updateRooms(type, status || { id: roomId }));
};
